import React from 'react';
import ReactDOM from 'react-dom';
import RootApp from './RootApp';
// import { register } from './serviceWorker'; // Desabilitado, ocorrendo erro

// Wrap the rendering in a function:
const render = () => ReactDOM.render(<RootApp />, document.getElementById('root'));

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// register(); //

// Render once
render();

// Webpack Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./RootApp', render);
}
